<script>
  import solicitacaoBolsaAtividadeServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import DatePicker from 'vue2-datepicker';

  export default {
    components: { Paginacao, Radio, ModalArquivosSolicitacao, DatePicker, ModalMensagem },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        atividades: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        pessoas: [],
        modalArquivos: false,
        atividadeSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '',
          idPessoa: '',
          mostrarAtividades: '0',
          periodo: '',
          filtrado: false,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.$nextTick(() => {
          $('#pessoas').val(0);
          $('#pessoas').trigger('change.select2');
        });

        this.errors.clear();

        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoBolsaAtividadeServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.atividades = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("SolBolsa")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDePessoas() {
        return solicitacaoBolsaAtividadeServico
          .listaDePessoas()
          .then(pessoas => {
            this.pessoas = pessoas;
          });
      },
      mostrarModalArquivos(atividade) {
        this.atividadeSelecionada = atividade;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.atividadeSelecionada = null;
      },  
      mostrarModalMensagem(atividade) {
        this.atividadeSelecionada = atividade;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.atividadeSelecionada = null;
        this.lista(this.pagina);
      },
      liberado(atividade) {
        return !!atividade.comAtividade;
      },
      tipoContrato(tipo) {
        if (tipo === 1) {
          return 'Bolsa';
        } else if (tipo === 2) {
          return 'RPA';
        } else if (tipo === 3) {
          return 'Estágio';
        } else if (tipo === 4) {
          return 'Termo aditivo';
        } else if (tipo === 5) {
          return 'Adicional variável';
        } else {
          return '';
        }
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de ' + this.configuracao.nomeModuloSolContratos + '  - Atividades Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();
      this.listaDePessoas();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      $('#pessoas').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idPessoa', this.value);
        });

      $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .liberada {
    font-size: 1.50em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .pendente {
    font-size: 1.50em;
    color: #f8c75a;
    margin-right: 3px;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="atividadeSelecionada ? atividadeSelecionada.idContratoAnaliseTecnica : ''"
                                tipo="atividadecontrato"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="atividadeSelecionada ? atividadeSelecionada.idSolicitacao : ''"
                    :numero="atividadeSelecionada ? atividadeSelecionada.idSolicitacaoBolsa : ''"
                    tipo="SolBolsa"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">

        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-8">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-xs-3">
                <div class="form-group">
                  <label class="control-label block">Mostrar atividades</label>

                  <radio v-model="filtros.mostrarAtividades"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todas
                  </radio>
                  <radio v-model="filtros.mostrarAtividades"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Aguardando liberação
                  </radio>
                  <radio v-model="filtros.mostrarAtividades"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Liberadas
                  </radio>
                </div>
              </div>

              <div class="col-xs-9">
                <div class="form-group">
                  <label class="control-label" for="pessoas">Beneficiário</label>

                  <select id="pessoas"
                          class="form-control"
                          v-model="filtros.idPessoa">
                    <option value="0">Todos</option>
                    <option :value="pessoa.idPessoa" v-for="(pessoa, index) in pessoas">{{ pessoa.nomePessoa }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
           </div>

            <div class="ibox-footer">

              <div class="table-responsive">
                <table class="table table-bordered table-column-code table-column-action">
                  <thead>
                    <tr>
                      <th v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolBolsa)">Mensagens</th>
                      <th class="text-center">Número</th>
                      <th>Tipo</th>
                      <th>Liberada</th>
                      <th>Data</th>
                      <th>Beneficiário</th>
                      <th>Valor (R$)</th>
                      <th>Valor liberado (R$)</th>
                      <th>Projeto</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(atividade, index) in atividades">
                      <td v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolBolsa)">
                        <div v-if="atividade.quantidadeNaoLida > 0">
                          <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{atividade.quantidadeNaoLida}}
                        </div>
                      </td>
                      <td class="text-center">{{ atividade.idSolicitacaoBolsa || '---' }}</td>
                      <td>{{ tipoContrato(atividade.tipoContrato) }}</td>
                      <td>
                        <div v-if="liberado(atividade)">
                          <i class="fa fa-check-circle-o liberada"></i> Liberada
                        </div>

                        <div v-if="!liberado(atividade)">
                          <i class="fa fa-exclamation-triangle pendente"></i> Pendente
                        </div>
                      </td>
                      <td>{{ atividade.dataAtividade | formatarData }}</td>
                      <td>{{ atividade.documento || '---' }} - {{ atividade.nome || '---' }}</td>
                      <td>{{ atividade.valor | formatarNumero }}</td>
                      <td>{{ atividade.valorLiberado | formatarNumero }}</td>
                      <td>{{ atividade.nomeProjeto || '---' }}</td>

                      <td>

                        <router-link tag="button"
                                     :disabled="liberado(atividade)"
                                     class="btn btn-warning btn-xs"
                                     active-class=""
                                     v-tooltip="'Liberar atividade'"
                                     :to="{ name: 'solicitacao-bolsa-atividades.editar', params: { idCript: atividade.idContratoAnaliseTecnicaCrypt } }">
                          <i class="fa fa-check"></i>
                        </router-link>

                        <button type="button"
                                class="btn btn-info btn-xs"
                                v-tooltip="'Listar ou adicionar arquivos da atividade'"
                                @click="mostrarModalArquivos(atividade)"
                                v-if="configuracao.usarArquivosAtividadeContrato">
                          <i class="fa fa-archive"></i>
                        </button>

                        <button type="button"
                                class="btn btn-success btn-xs"
                                v-tooltip="'Ler\Enviar mensagem'"
                                @click="mostrarModalMensagem(atividade)"
                                v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolBolsa)">
                          <i class="fa fa-comment"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-show="carregando">
                      <td colspan="8">
                        <i class='fa fa-spinner fa-pulse'></i> Carregando...
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <paginacao :page-count="totalPaginas"
                         :click-handler="lista"
                         :per-page="registrosPorPagina"
                         :register-count="totalRegistros"
                         :show-counter="true">
              </paginacao>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa-atividades/componentes/SolicitacaoBolsaAtividadesLista.vue